var exports = {
  "CB": "RoleManagement.module__roleIndicator___eVNveE",
  "KG": "RoleManagement.module__roleBadge___eVNveE",
  "Gy": "RoleManagement.module__roleRemoveButtonContainer___eVNveE",
  "j1": "RoleManagement.module__roleRemoveButton___eVNveE",
  "r4": "RoleManagement.module__roleRemoveIconContainer___eVNveE",
  "S3": "RoleManagement.module__roleName___eVNveE",
  "MR": "RoleManagement.module__roleListContainer___eVNveE",
  "ek": "RoleManagement.module__assignRoleButton___eVNveE",
  "JO": "RoleManagement.module__assignRoleButtonIcon___eVNveE",
  "RK": "RoleManagement.module__iconSize___eVNveE",
  "Xk": "RoleManagement.module__noRolesLink___eVNveE",
  "X9": "RoleManagement.module__roleColorIndicator___eVNveE",
};

module.exports = exports;
